// @ts-nocheck
import { REQUIRED_LIST_ERROR, REQUIRED_LIST_LOADING, REQUIRED_LIST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const RequiredListReducer = (state = initialState, action) => {
    switch (action.type) {
        case REQUIRED_LIST_LOADING:
            return Object.assign({}, state, { loading: true })
        case REQUIRED_LIST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case REQUIRED_LIST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

